<template>
	<div>
		<HeaderComponent :locals="locals" />
		<router-view :locals="locals" />
		<FooterComponent :locals="locals" />
	</div>
</template>

<script>
import axios from 'axios';
import HeaderComponent from '@/components/HeaderComponent.vue';
import FooterComponent from '@/components/FooterComponent.vue';

export default {
	data() {
		return {
			locals: {},
		};
	},
	async created() {
		try {
			setTimeout(() => {
				const reloginCookie = document.cookie.split('; ').find((row) => row.startsWith('relogin='));
				if (reloginCookie) {
					const encodedUrl = reloginCookie.split('=')[1];
					const redirectUrl = decodeURIComponent(encodedUrl);
					document.cookie = 'relogin=; Max-Age=0; path=/';
					return (window.location.href = redirectUrl + `&redirect=/`);
				}
			}, 500);
			const response = await axios.get('/acl/locals');
			this.locals = response.data;
		} catch (error) {
			console.error('Error fetching locals:', error);
		}
	},
	components: {
		HeaderComponent,
		FooterComponent,
	},
};
</script>
